import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { PowerSettingsDefaultValueService } from './power-settings/power-settings-default-value.service';
import { PowerSmartStandbyDefaultValueService } from './power-smart-standby/power-smart-standby-dafault-value.service';
import { PowerBatterySettingsDefaultValueService } from './power-battery-settings/power-battery-settings-default-value.service';

@Injectable({
	providedIn: 'root'
})
export class PowerDefaultValueService {

	constructor(
		private powerSettingsDefaultValue: PowerSettingsDefaultValueService,
		private smartStandbyDefaultValue: PowerSmartStandbyDefaultValueService,
		private batterySettingsDefaultValue: PowerBatterySettingsDefaultValueService,
	) { }

	public initialize(adTags: any) {
		this.smartStandbyDefaultValue.initialize(adTags);
		this.powerSettingsDefaultValue.initialize(adTags);
		this.batterySettingsDefaultValue.initialize(adTags);
	}
}
